import {MI} from "../init";
import {wallet} from "../../framework/src/engine/madnes/madnes_variables";
import {creditToMoney} from "../../framework/src/wallet/walletOperations";

/**
 * @constructor
 * @param {Game} game
 * @returns {WinCounter}
 */
export default function WinCounter(game) {

    /** @type {Game}  */
    this._game = game;

    this._from = 0;
    this._to = 0;

    this._startTime = 0;
    this._totalTime = 0;

    this._onUpdate = function(val) {};
    this._onEnd = function(val) {};

    this._fps = 25;
}

WinCounter.prototype.setOnUpdate = function(func) {
    this._onUpdate = func;
};

WinCounter.prototype.setOnEnd = function(func) {
    this._onEnd = func;
};

WinCounter.prototype.run = function(from, to, time) {

    var _self = this;

    let oldWin = wallet.getWin();

    this._from = from;
    this._to = to;
    this._totalTime = time;
    this._startTime = MI.getTime();

    var timer = MI.createTimer().loop(function() {

        var perc = (MI.getTime() - _self._startTime) / _self._totalTime;
        if(perc >= 1) {
            timer.stop();
            _self._onEnd(_self._to);
            _self._game.setWin(oldWin + creditToMoney(_self._to, wallet.getCoin(), wallet.getDecimalPlaces()));
            timer = null;
        } else {

            var val = _self._to * perc + _self._from;
            _self._onUpdate(val);
            _self._game.setWin(oldWin + creditToMoney(val, wallet.getCoin(), wallet.getDecimalPlaces()));
        }

    }, 1000 / this._fps);
};